
export enum PaperChatFilterType {
  ALL = 'ALL',
  SCREENING_ONE = 'SCREENING_ONE',
  SCREENING_TWO = 'SCREENING_TWO',
  SINGLE='SINGLE'
}

export enum PaperChatWebsocketState {
  START = 'START',
  END = 'END',
  MESSAGE = 'MESSAGE'
}
export interface PaperChatWebsocketCreateDTO{
  timestamp: number;
  message: string;
}

export interface PaperChatWebsocketDTO extends PaperChatWebsocketCreateDTO {
  projectId: number;
  sender: boolean;
  state: PaperChatWebsocketState
}
